// extracted by mini-css-extract-plugin
var _1 = "ExpandedPostModalCommentThread-module__animateUploadProgressBarWidth--yD0OO";
var _2 = "ExpandedPostModalCommentThread-module__animatedBackground--cRgBm";
var _3 = "ExpandedPostModalCommentThread-module__authorName--nRCvV";
var _4 = "ExpandedPostModalCommentThread-module__avatar--fN3xR";
var _5 = "ExpandedPostModalCommentThread-module__comment--Y1xZJ";
var _6 = "ExpandedPostModalCommentThread-module__commentAvatar--jyljD";
var _7 = "ExpandedPostModalCommentThread-module__commentContent--satXR";
var _8 = "ExpandedPostModalCommentThread-module__commentMeta--HzQq2";
var _9 = "ExpandedPostModalCommentThread-module__container--Ax08i";
var _a = "ExpandedPostModalCommentThread-module__icon--ebQ4h";
var _b = "ExpandedPostModalCommentThread-module__replyButton--qRi8y";
var _c = "ExpandedPostModalCommentThread-module__time--SKnQd";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "authorName", _4 as "avatar", _5 as "comment", _6 as "commentAvatar", _7 as "commentContent", _8 as "commentMeta", _9 as "container", _a as "icon", _b as "replyButton", _c as "time" }
